"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var OrderHistory1 = function OrderHistory1(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "OrderHistory1"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "order-history-1"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.26 17.14l-2.48-16.34c-0.002-0.009-0.003-0.019-0.003-0.030s0.001-0.021 0.003-0.031l-0 0.001v-0.080c0.002-0.018 0.003-0.039 0.003-0.060s-0.001-0.042-0.003-0.063l0 0.003-0.16-0.1-0.040-0.060s0 0 0 0v0l-0.080-0.12-0.080-0.060-0.16-0.080-0.060-0.040v-0.020c-0.101-0.033-0.217-0.055-0.337-0.060l-0.003-0h-11.76c-0.003-0-0.006-0-0.009-0-0.574 0-1.076 0.31-1.347 0.773l-0.004 0.007-1.32 2.3c-0.147 0.264-0.234 0.578-0.234 0.913 0 0.97 0.726 1.77 1.665 1.886l0.009 0.001-2.12 11.16c-0.027 0.14-0.043 0.301-0.043 0.465 0 0.606 0.212 1.163 0.567 1.599l-0.004-0.005c0.462 0.551 1.15 0.9 1.92 0.9h13.62c1.365-0.006 2.469-1.114 2.469-2.48 0-0.134-0.011-0.266-0.031-0.394l0.002 0.014zM4.3 1.9h9.6l-1.32 1.74c-0.166 0.208-0.42 0.34-0.705 0.34-0.005 0-0.011-0-0.016-0l0.001 0h-8.8zM12.2 16.76l-0.1 0.6c-0.078 0.422-0.442 0.737-0.88 0.74h-8.020c-0.002 0-0.003 0-0.005 0-0.184 0-0.348-0.085-0.454-0.219l-0.001-0.001c-0.082-0.099-0.131-0.227-0.131-0.367 0-0.040 0.004-0.079 0.012-0.117l-0.001 0.004 2.2-11.5h7.040c0.909-0.012 1.711-0.454 2.215-1.132l0.005-0.008 0.2-0.18-2.080 12.16zM17.26 17.9c-0.107 0.123-0.264 0.2-0.438 0.2-0.001 0-0.001 0-0.002 0h-1.86c-0.493-0.005-0.891-0.406-0.891-0.9 0-0.049 0.004-0.098 0.012-0.145l-0.001 0.005 1.72-10.12 1.6 10.48c0.003 0.023 0.004 0.049 0.004 0.075 0 0.154-0.055 0.296-0.145 0.406l0.001-0.001zM10.72 9.28h-4.3c-0.467 0.070-0.822 0.469-0.822 0.95s0.354 0.88 0.817 0.949l0.005 0.001h4.3c0.467-0.070 0.822-0.469 0.822-0.95s-0.354-0.88-0.817-0.949l-0.005-0.001z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = OrderHistory1;
exports["default"] = _default;